module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.goDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('span', [_vm._v(_vm._s(order.title))])]), _vm._v(" "), (order.timetaken == 0) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                未答题\n                            ")]) : _c('div', {
      staticClass: "title-right green"
    }, [_vm._v("\n                                已答题\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "justify-space-flex row-goods"
    }, [_c('div', {
      staticClass: "row-left flex-start"
    }, [_c('div', {
      staticClass: "goods-detail"
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(order.desc))]), _vm._v(" "), (order.timetaken != 0) ? _c('div', {
      staticClass: "goods-weight gray-light"
    }, [_vm._v("\n                                        " + _vm._s(order.submit_time) + "\n                                    ")]) : _vm._e()])]), _vm._v(" "), (order.timetaken != 0) ? _c('div', {
      staticClass: "row-right"
    }, [_c('div', {
      staticClass: "goods-price"
    }, [_c('span', [_vm._v("总分")]), _vm._v(_vm._s(order.totalvalue))]), _vm._v(" "), _c('div', {
      staticClass: "goods-num gray-light"
    }, [_vm._v("总分" + _vm._s(order.fullscore) + " 用时 " + _vm._s(order.timetaken))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, [(order.timetaken == 0) ? _c('div', {
      staticClass: "look-order"
    }, [_vm._v("开始答题")]) : _vm._e()])])
  }), 0)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-638a783e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/wexame/MyExameList.vue
// module id = 1450
// module chunks = 0